export default [
	{
		path: '/supermarket',
		name: 'supermarket',
		meta: {
			exp: '科技服务超市',
			requireAuth: false
		},
		component: () => import('@/views/supermarket/index.vue')
	},
	{
		path: '/supermarket/shop_home',
		name: 'shop_home',
		meta: {
			exp: '店铺首页',
			requireAuth: false
		},
		redirect: '/supermarket/shop_home/home',
		component: () => import('@/views/supermarket/shop_home/index.vue'),
		children: [
			{
				path: '/supermarket/shop_home/home',
				name: 'shop_home_index',
				meta: {
					exp: '店铺首页',
					requireAuth: false
				},
				component: () => import('@/views/supermarket/shop_home/home/index.vue')
			},
			{
				path: '/supermarket/shop_home/goods_list',
				name: 'shop_home_goods_list',
				meta: {
					exp: '店铺商品列表',
					requireAuth: false
				},
				component: () => import('@/views/supermarket/shop_home/goods_list/index.vue')
			},
			{
				path: '/supermarket/shop_home/introduction',
				name: 'shop_home_introduction',
				meta: {
					exp: '店铺简介',
					requireAuth: false
				},
				component: () => import('@/views/supermarket/shop_home/introduction/index.vue')
			},
			{
				path: '/supermarket/shop_detail',
				name: 'shop_detail',
				meta: {
					exp: '商品详情页',
					requireAuth: false
				},
				component: () => import('@/views/supermarket/shop_detail/index.vue'),
			},
		]
	},
	{
		path: '/supermarket/goods_list',
		name: 'goods_list',
		meta: {
			exp: '商品列表',
			requireAuth: false
		},
		component: () => import('@/views/supermarket/goods_list/index.vue')
	},

	{
		path: '/supermarket/confirm_order',
		name: 'confirm_order',
		meta: {
			exp: '订单确认',
			requireAuth: false
		},
		component: () => import('@/views/supermarket/confirm_order/index.vue')
	},
	{
		path: '/supermarket/store_list',
		name: 'store_list',
		meta: {
			exp: '店铺列表',
			requireAuth: false
		},
		component: () => import('@/views/supermarket/shop_list/index.vue')
	},

]
